"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
// English shortened
var strings = {
  prefixAgo: null,
  prefixFromNow: null,
  suffixAgo: '',
  suffixFromNow: '',
  seconds: '1წმ',
  minute: '1წთ',
  minutes: '%dწთ',
  hour: '1სთ',
  hours: '%dსთ',
  day: '1დღე',
  days: '%dდღე',
  month: '1თვე',
  months: '%dთვე',
  year: '1წ',
  years: '%dწ',
  wordSeparator: ' '
};
var _default = strings;
exports["default"] = _default;